import * as React from 'react'
function SvgChevronLeft(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M23.133 32.533l-9.705-9.705a4 4 0 010-5.656l9.705-9.705a2.64 2.64 0 013.734 3.733l-8.8 8.8 8.8 8.8a2.64 2.64 0 01-3.734 3.733z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgChevronLeft
